import { apiClient } from "../../../service";

export const loginApi = ({ username, password }) =>
  apiClient.post(`/auth/login`, { username, password });
export const logoutApi = () => apiClient.delete(`/auth/logout`);
export const checkUserApi = () => apiClient.get(`/auth/profile`);
